import React from "react";
import { CouponTableProps, CouponTableState } from "./models";


import { Box, IconButton, Stack } from "@mui/material";
import DeleteIcon from '@mui/icons-material/Delete';

import MaterialReactTable from 'material-react-table';
import type { MRT_ColumnDef } from 'material-react-table';

import EditIcon from "@mui/icons-material/Edit";

import { t } from "@lingui/macro";

import { Coupon } from "models";
import { ConfirmModal } from "commons/modal/confirm-modal";


export class CouponTable extends React.Component<CouponTableProps, CouponTableState>
{
    private tableColumns: MRT_ColumnDef[];

    public constructor(props: any) {

        super(props)

        this.state={
            openConfirmModal: false,
            couponToDelete: ""
        }

        this.tableColumns = [
            {
                header: t({
                    id: "ct-table-col-discount-code",
                    message: "Codice"
                }),
                accessorKey: "code",
                Cell: ({ cell }) => {
                    return (
                        <Box>
                            {cell.getValue<string>()}
                        </Box>
                    );
                },
            },
            {
                header: t({
                    id: "ct-table-col-discount",
                    message: "Sconto"
                }),
                accessorKey: "value",
                Cell: ({ cell }) => {
                    return (
                        <Box>
                            {`${cell.getValue<string>()}%`}
                        </Box>
                    );
                },
            },
        ];
    }

    private openConfirmModal = (id: string) : void =>{
        this.setState(() => ({
            openConfirmModal: true,
            couponToDelete: id
        }))
    }

    private cancelConfirmModalCallback = () : void =>{
        this.setState(() => ({
            openConfirmModal: false,
            couponToDelete: ""
        }))
    }

    private acceptConfirmModal = () : void =>{
        this.setState(() => ({
            openConfirmModal: false,
        }))
        this.deleteCoupon()
    }

    private deleteCoupon = (): void => {
        this.props.deleteCoupon(this.state.couponToDelete);
        this.setState(() => ({
            couponToDelete: ""
        }))

    }

    private getIdValue = (row: any): string => {
        return row.original.id
    }

    private openEditModal = (coupon: any) => {
        this.props.openEditCouponTable(coupon as Coupon);
    }

    private handlePageChange = (updateFn: any) => {
        let newPagination = updateFn(this.props.pagination);
        this.props.updatePaginationCallBackFn(newPagination);
    }    

    render() {
        return (
            <>
            <Box style={{ maxWidth: '100%' }}>
                <MaterialReactTable
                    columns={this.tableColumns}
                    rowCount={this.props.totalCouponCount}
                    pageCount={Math.ceil(this.props.totalCouponCount / this.props.pagination.pageSize)}
                    data={this.props.coupons}
                    enableRowSelection={false}
                    enableColumnOrdering={false}
                    enableColumnActions={false}
                    enableGlobalFilter={false}
                    enableFilters={false}
                    muiTableHeadCellProps={{
                        sx: {
                            color: "white",
                            backgroundColor: process.env.REACT_APP_PRIMARY_COLOR
                        }
                    }}
                    displayColumnDefOptions={{
                        'mrt-row-actions': {
                            header: ""
                        }
                    }}
                    enableRowActions
                    positionActionsColumn="last"
                    renderRowActions={({ row }) => (
                        <Stack direction={"row"} display={"flex"} justifyContent={"right"} >
                            <IconButton onClick={() => this.openEditModal(row.original)}>
                                <EditIcon />
                            </IconButton>
                            <IconButton onClick={() => this.openConfirmModal(this.getIdValue(row))}>
                                <DeleteIcon />
                            </IconButton>
                        </Stack>
                    )}
                    onPaginationChange={this.handlePageChange}
                    enableTopToolbar={false}
                    manualPagination={true}
                    autoResetPageIndex={false}
                    enableDensityToggle={false}
                    state={{
                        pagination: this.props.pagination
                    }} />
            </Box>
        {this.state.openConfirmModal && <ConfirmModal
            cancelConfirmCallback={this.cancelConfirmModalCallback}
            confirmCallback={this.acceptConfirmModal}
            text={"Sei sicuro di voler procedere con l'eliminazione del coupon?"}
            textId={"ct-delete-coupon-text"}
        />}
    </>)
    }
}
